import { MemCache } from '@nu-art/thunderstorm-frontend/index';
export class AdvisorRuntimeMemCache extends MemCache {
    async load() {
        const moduleName = this.module.getName();
        this.module.logDebugBold(`${moduleName} cache is loading`);
        let allItems;
        if (this.cacheFilter)
            allItems = await this.module.IDB.filter(this.cacheFilter);
        else
            allItems = await this.module.IDB.query();
        const frozenItems = allItems.map((item) => Object.freeze(item));
        this.setCache(frozenItems);
        this.loaded = true;
        this.module.logDebug(`${moduleName} cache finished loading, count: ${this.all().length}`);
    }
}
//# sourceMappingURL=AdvisorRuntimeMemCache.js.map